import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Menu, Icon, Button, Header, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  Select,
  SemanticTable,
  ContainerData,
  Label,
  Data,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import { isAuthAdmin } from "../../../../../services/auth";

const PedidosExtensao = (props) => {
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [excel, setExcel] = useState("");
  const [statusValue, setStatusValue] = useState("T");
  const [search, setSearch] = useState({
    filter: "",
    dataIni: "",
    dataFinal: "",
    status: "1",
  });
  const status = [
    { id: 1, value: "TODOS" },
    { id: 2, value: "PENDENTE" },
    { id: 3, value: "RESPONDIDO" },
  ];

  useEffect(() => {
    loadExcel();
    loadPedidos();
  }, []);

  const loadExcel = () => {
    api.get("admin/pedidos_extensao/generateExcel").then((res) => {
      setExcel(res.data);
    });
  };

  const loadPedidos = async () => {
    try {
      const response = await api.get(
        `admin/pedidos_extensao?dataInicio=${search.dataIni}&dataFinal=${search.dataFinal}&amount=20&page=1&filter=${search.filter}`
      );
      let logs = { local: "ead/pedidosExtensao", texto: `listou os pedidos` };
      await api.post("system_logs", { acao: JSON.stringify(logs) });
      const { data } = response;
      setPedidos(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const changeStatus = useCallback(
    (id, resposta, index) => {
      const newResposta = resposta == "S" ? "N" : "S";
      api
        .put(`admin/pedidos_extensao/${id}`, { respondido: newResposta })
        .then(async (res) => {
          let logs = {
            local: "ead/pedidosExtensao",
            texto: `editou o status do pedido de id=${id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          const newPedidos = pedidos;
          newPedidos[index]["respondido"] = newResposta;
          setPedidos([...newPedidos]);
        })
        .catch((err) => swal("Não foi possivel mudar o status", err, "error"));
    },
    [pedidos]
  );

  const valueStatus = (valor) => {
    if (valor == 1) {
      setStatusValue("T");
    } else {
      valor == 2 ? setStatusValue("N") : setStatusValue("S");
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Pedidos PedidosExtensão</Title>
            <ContainerData>
              <Data>
                <Label>
                  Status:
                  <Select
                    value={search.status}
                    onChange={(e) => {
                      setSearch({ ...search, status: e.target.value });
                      loadPedidos();
                      valueStatus(e.target.value);
                    }}
                  >
                    {status.map((valor) => (
                      <option value={valor.id}>{valor.value}</option>
                    ))}
                  </Select>
                </Label>
              </Data>
              <Button href={excel}>Excel</Button>
            </ContainerData>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Digite o email, nome ou id..."
                value={search.filter}
                onChange={(e) => {
                  setSearch({ ...search, filter: e.target.value });
                  loadPedidos();
                }}
              />
              <Icon name="search icon" />
            </ContainerInputSearch>
            <ContainerData>
              <Data>
                <Label>
                  A partir de:
                  <Input
                    type="date"
                    value={search.dataIni}
                    onChange={(e) => {
                      setSearch({ ...search, dataIni: e.target.value });
                      loadPedidos();
                    }}
                  />
                </Label>
              </Data>
              <Data>
                <Label>
                  Até:
                  <Input
                    type="date"
                    value={search.dataFinal}
                    onChange={(e) => {
                      setSearch({ ...search, dataFinal: e.target.value });
                      loadPedidos();
                    }}
                  />
                </Label>
              </Data>
            </ContainerData>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Id_Aluno</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Celular</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Id_curso </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Data</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Descrição</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>

              <SemanticTable.Body>
                {pedidos
                  .filter(
                    (pedido) =>
                      pedido.respondido == statusValue || statusValue === "T"
                  )
                  .map((pedido, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{pedido.id_aluno}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {pedido.aluno.nome}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {pedido.aluno.celular}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>{pedido.id_curso}</SemanticTable.Cell>
                      <SemanticTable.Cell>{pedido.data}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {pedido.pedido_txt}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <>
                          <Button
                            icon={pedido.respondido == "S" ? "check" : "close"}
                            color={pedido.respondido == "S" ? "green" : "red"}
                            onClick={() =>
                              changeStatus(pedido.id, pedido.respondido, index)
                            }
                          />
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(PedidosExtensao);
